class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    // Dynamically find the main toggle element (either <details> or <div>)
    this.mainDetailsToggle = this.querySelector('details') || this.querySelector('div');
    if (!this.mainDetailsToggle) return; // Stop if no suitable element is found

    // Ensure the content is identified correctly
    this.content = this.mainDetailsToggle.querySelector('summary') 
      ? this.mainDetailsToggle.querySelector('summary').nextElementSibling 
      : this.mainDetailsToggle.querySelector(':scope > .skb-mega-menu__overlay');

    if (!this.content) return; // Stop if no content element is found

    // Event listeners for behavior
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (this.mainDetailsToggle.tagName === 'DETAILS') {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.headerElement = document.querySelector('.header');
    
    // Find the parent mega-menu__mega-menu-item if it exists
    this.megaMenuItem = this.closest('.mega-menu__mega-menu-item');
    
    // Timeout for handling gaps between menu item and overlay
    this.hoverTimeout = null;
    
    // Setup hover handlers
    if (this.megaMenuItem && this.headerElement) {
      this.setupHoverHandlers();
    }
  }

  setupHoverHandlers() {
    // Get the mega menu overlay
    const megaMenuOverlay = this.querySelector('.skb-mega-menu__overlay');
    
    const addActiveClass = () => {
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = null;
      }
      this.headerElement.classList.add('header_megamenu_active');
    };
    
    const removeActiveClass = () => {
      // Small delay to allow mouse to move between item and overlay
      this.hoverTimeout = setTimeout(() => {
        this.headerElement.classList.remove('header_megamenu_active');
        this.hoverTimeout = null;
      }, 100);
    };
    
    // Handle mouseenter on mega menu item
    this.megaMenuItem.addEventListener('mouseenter', addActiveClass);
    
    // Handle mouseleave on mega menu item
    this.megaMenuItem.addEventListener('mouseleave', (e) => {
      // Check if moving to overlay
      if (megaMenuOverlay && megaMenuOverlay.contains(e.relatedTarget)) {
        return; // Keep class active
      }
      removeActiveClass();
    });
    
    // Handle mouseenter on overlay (in case there's a gap)
    if (megaMenuOverlay) {
      megaMenuOverlay.addEventListener('mouseenter', addActiveClass);
      megaMenuOverlay.addEventListener('mouseleave', removeActiveClass);
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.hasAttribute('open') || false;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
